<div
  class="item-wrapper"
  [ngClass]="{ 'item-wrapper-unaccounted': item.suiteType === suiteTypeEnum.Unaccounted }"
  (click)="showDetailsOverlay(overlayOrigin)"
>
  <div
    class="item-header"
    [ngClass]="[
      !isContentOn ? 'full-height' : '',
      item.suiteType === suiteTypeEnum.Availability ? 'expire-avail' : '',
      item.suiteType !== suiteTypeEnum.Availability && !!itemClass && isFilterOn
        ? itemClass + '__hide'
        : itemClass
          ? itemClass
          : '',
      item.suiteType !== suiteTypeEnum.Availability && !!itemClass && !isFilterOn ? itemClass : '',
      itemDataToDisplay.tag != null ? 'item-alignment' : '',
    ]"
  >
    <div
      #overlayOrigin
      class="item-header__title"
      [ngClass]="itemDataToDisplay.tag != null ? 'tag-displayed' : ''"
      [matTooltip]="itemDataToDisplay.title || ('commonLabels.unknown' | xTranslate)"
    >
      {{ itemDataToDisplay.title || ('commonLabels.unknown' | xTranslate) }}
    </div>
    <div class="item-header__tag" *ngIf="itemDataToDisplay.tag != null">
      &#x2605; <span class="item-header__tag__desc">{{ itemDataToDisplay.tag | xTranslate }}</span>
    </div>
  </div>
  <div class="item-content" *ngIf="isContentOn">
    <!-- TODO: Values below must be displayed dynamically depending on the options and not the type of data -->
    <div
      class="item-content__row"
      *ngIf="settings?.cardDetails.spaceSize"
      [ngClass]="{ 'item-content__unknown': item.suiteType === suiteTypeEnum.Unknown }"
    >
      {{ itemDataToDisplay.spaceSize || ('commonLabels.na' | xTranslate) }}
    </div>
    <div
      class="item-content__time item-content__row"
      *ngIf="settings?.cardDetails.leaseEndingDate && itemDataToDisplay.hasOwnProperty('leaseEndingDate')"
    >
      <span *ngIf="itemDataToDisplay.isOwnerOccupied && !itemDataToDisplay.leaseEndingDate"> Owner </span>
      <span *ngIf="itemDataToDisplay.isOwnerOccupied && itemDataToDisplay.leaseEndingDate">
        Owner ({{ itemDataToDisplay.leaseEndingDate | getDateString: 'MM/YYYY' }})
      </span>
      <span *ngIf="!itemDataToDisplay.isOwnerOccupied">
        {{ (itemDataToDisplay.leaseEndingDate | getDateString: 'MM/YYYY') || ('commonLabels.na' | xTranslate) }}
      </span>
    </div>
    <div class="item-content__time item-content__row" *ngIf="settings?.cardDetails.rentDate">
      {{ itemDataToDisplay.rentDate || ('commonLabels.na' | xTranslate) }}
    </div>
    <div class="item-content__time item-content__row" *ngIf="settings?.cardDetails.showLeaseRate">
      {{ itemDataToDisplay.leaseRate || ('commonLabels.na' | xTranslate) }}
    </div>
    <div class="item-content__time item-content__row" *ngIf="settings?.cardDetails.suiteNumber">
      {{ 'actionsToolbar.suite' | xTranslate }}
      {{ itemDataToDisplay.suiteNumber || ('commonLabels.na' | xTranslate) }}
    </div>
    <div class="item-content__time item-content__row" *ngIf="settings?.cardDetails.tenantRepAgency">
      {{ itemDataToDisplay.tenantRepAgency || ('commonLabels.na' | xTranslate) }}
    </div>
  </div>
</div>
